



import Vue from "vue";
import {Component} from "vue-property-decorator";
import parameters from "@/config/parameters";

@Component({
  name: 'NavigationBar',
  components: {
  }
})
export default class NavigationBar extends Vue {
  public mainURL: string;
  public highlightedNavTabs: {
    project: boolean,
    pilots: boolean,
    partners: boolean,
    media: boolean,
    contact: boolean,
    policies: boolean,
    routes: boolean,
  }

  constructor() {
    super();
    this.mainURL = parameters.projectWebAddress;
    this.highlightedNavTabs = {
      project: false,
      pilots: false,
      partners: false,
      media: false,
      contact: false,
      policies: false,
      routes: false,
    }
  }
}
